import { render, staticRenderFns } from "./AllQuotes.vue?vue&type=template&id=419a1064&"
import script from "./AllQuotes.vue?vue&type=script&lang=js&"
export * from "./AllQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports